var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.body)?_c('div',{staticClass:"partners"},_vm._l((_vm.body.partners),function(partner){return _c('ItemPartner',{key:partner._uid,attrs:{"partner":partner}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }